"use strict";

exports.__esModule = true;
exports.withScrollWindow = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _gsap = require("gsap");

var _ramda = require("ramda");

var _ScrollToPlugin = _interopRequireDefault(require("gsap/umd/ScrollToPlugin"));

var _excluded = ["animating", "duration", "easing", "scrollValue", "updateAnimation"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-line no-unused-vars
var propTypes = {
  animating: _propTypes.bool,
  children: _propTypes.node,
  duration: _propTypes.number,
  easing: (0, _propTypes.arrayOf)(_propTypes.string),
  scrollValue: _propTypes.number,
  updateAnimation: _propTypes.func
};
var defaultProps = {
  duration: 0.25,
  easing: ["Power4", "easeOut"],
  scrollValue: null
};

var withScrollWindow = function withScrollWindow(Component) {
  var ScrollWindow = function ScrollWindow(_ref) {
    var animating = _ref.animating,
        duration = _ref.duration,
        easing = _ref.easing,
        scrollValue = _ref.scrollValue,
        updateAnimation = _ref.updateAnimation,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);

    (0, _react.useEffect)(function () {
      if (animating && scrollValue) {
        var docWindow = window || document.documentElement;

        _gsap.TweenLite.to(docWindow, duration, {
          ease: easing.join("."),
          onComplete: function onComplete() {
            if ((0, _ramda.is)(Function, updateAnimation)) {
              updateAnimation(false);
            }
          },
          scrollTo: {
            y: scrollValue
          }
        });
      }
    }, [animating, duration, easing, scrollValue, updateAnimation]);
    return /*#__PURE__*/_react["default"].createElement(Component, props);
  };

  ScrollWindow.propTypes = propTypes;
  ScrollWindow.defaultProps = defaultProps;
  return ScrollWindow;
};

exports.withScrollWindow = withScrollWindow;
var _default = withScrollWindow;
exports["default"] = _default;